import { useEffect, useState, memo } from "react";
import { profileImage } from "../../../data/main.data";
import { useZustand } from "../../../zustand/store";

let timeOutId: any;
function ProfileImageSwitch() {
  // const {currentDisplayedProfile, setCurrentDisplayedProfile} = useZustand();
  const [imgUrl, setImageUrl] = useState(profileImage.images[0]);

  useEffect(() => {

    if (profileImage.multiple) {
      const maxIndex = profileImage.images.length - 1;
      let nextImgUrl;

      clearTimeout(timeOutId);
      timeOutId = setTimeout(() => {
        const currentIndex = profileImage.images.indexOf(imgUrl);
        
        if (currentIndex < maxIndex) {
          nextImgUrl = profileImage.images[currentIndex + 1];
        } else {
          nextImgUrl = profileImage.images[0];
        }

        setImageUrl(nextImgUrl);
      }, 2500);
    }

  }, [imgUrl]);

  

  return (
    <div className="w-full h-full pl-5 md:pl-10">
      <img src={imgUrl} alt="Profile" className="rounded-full w-full" />
    </div>
  );
}

export default memo(ProfileImageSwitch);
